"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const imageUrl_1 = require("../../../resource/imageUrl");
const VerticalFocus_1 = __importDefault(require("./VerticalFocus"));
const ArroundSearchButton = styled_components_1.default.button `
  display: flex;
  align-items: center;
  gap: 14px;

  width: 100%;
  height: 40px;

  margin: 9px 0;
  padding: 0 20px;

  font-size: 0.9375rem;
  font-weight: 500;
  letter-spacing: -0.0469rem;
  color: #202020;

  box-sizing: border-box;

  .Search__Arround__Img {
    position: relative;
    top: 1px;

    width: 16px;
    height: 19.9px;
  }

  &:hover {
    background-color: #f1f1f1;
    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  &:focus {
    background-color: #f1f1f1;
    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }
`;
const CommonDeskArroundSearch = ({ onArroundSearch }) => {
    const onKeyDown = (e) => {
        if (e.code === "ArrowUp" ||
            e.code === "ArrowLeft" ||
            e.code === "ArrowRight") {
            e.preventDefault();
            const $input = document.body.querySelector("input");
            $input?.focus();
            return;
        }
        if (e.code === "ArrowDown" || e.code === "Tab") {
            e.preventDefault();
            const $Recent = document.body.querySelector(".Recent__List__Box");
            const $List = $Recent?.children;
            if ($List) {
                const $target = $List[0].children[0];
                $target.focus();
                return;
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(ArroundSearchButton, { className: "Search__Arround__Button", onClick: onArroundSearch, onKeyDown: onKeyDown, children: [(0, jsx_runtime_1.jsx)(VerticalFocus_1.default, { height: "42px" }), (0, jsx_runtime_1.jsx)("img", { className: "Search__Arround__Img", src: imageUrl_1.search_input.logo_img, alt: "" }), "\uB0B4\uC8FC\uBCC0 \uAC80\uC0C9"] }));
};
exports.default = CommonDeskArroundSearch;
